// Distritos de Lima que ofrece el selector del mapa / registro.
export const DISTRITOS = [
  'Jesús María', 'Lince', 'San Isidro', 'Miraflores', 'Barranco', 'Surquillo',
  'San Borja', 'Santiago de Surco', 'La Victoria', 'Breña', 'Pueblo Libre',
  'Magdalena del Mar', 'San Miguel', 'Rímac', 'Lima', 'El Agustino',
  'Santa Anita', 'Ate', 'La Molina', 'Chorrillos', 'San Juan de Miraflores',
  'Villa El Salvador', 'Villa María del Triunfo', 'San Juan de Lurigancho',
  'San Luis', 'San Martín de Porres', 'Los Olivos', 'Independencia', 'Comas',
  'Carabayllo', 'Puente Piedra', 'Ancón', 'Santa Rosa', 'La Punta', 'Carmen de la Legua',
  'Bellavista', 'Callao', 'Chaclacayo', 'Cieneguilla', 'Lurín', 'Pachacámac',
  'Pucusana', 'Punta Hermosa', 'Punta Negra', 'San Bartolo', 'Santa María del Mar',
  'Lurigancho',
];

export const DISTRITO_DEFECTO = DISTRITOS[0];

const CACHE_DISTRITOS = new Map();

// Resuelve la geometría de un distrito (polígono + boundingbox + centro)
// contra Nominatim. Devuelve null si no se encuentra. Cachea por sesión.
export const obtenerDistrito = async (nombre) => {
  if (CACHE_DISTRITOS.has(nombre)) return CACHE_DISTRITOS.get(nombre);
  try {
    const params = new URLSearchParams({
      q: `${nombre}, Lima, Perú`,
      format: 'json',
      polygon_geojson: '1',
      addressdetails: '1',
      limit: '1',
      countrycodes: 'pe',
    });
    const res = await fetch(`https://nominatim.openstreetmap.org/search?${params}`);
    const data = await res.json();
    const info = data[0] || null;
    CACHE_DISTRITOS.set(nombre, info);
    return info;
  } catch {
    return null;
  }
};

// Algoritmo de "ray casting" sobre un anillo GeoJSON ([lng, lat], ...).
const enAnillo = (lat, lng, anillo) => {
  let dentro = false;
  for (let i = 0, j = anillo.length - 1; i < anillo.length; j = i++) {
    const xi = anillo[i][0];
    const yi = anillo[i][1];
    const xj = anillo[j][0];
    const yj = anillo[j][1];
    const cruza = (yi > lat) !== (yj > lat)
      && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (cruza) dentro = !dentro;
  }
  return dentro;
};

// ¿El punto (lat, lng) cae dentro del distrito (GeoJSON Polygon/MultiPolygon)?
export const puntoEnDistrito = (lat, lng, geojson) => {
  if (!geojson || !geojson.coordinates) return true;
  if (geojson.type === 'Polygon') {
    return enAnillo(lat, lng, geojson.coordinates[0]);
  }
  if (geojson.type === 'MultiPolygon') {
    return geojson.coordinates.some((poligono) => enAnillo(lat, lng, poligono[0]));
  }
  return true;
};

// Convierte un GeoJSON Polygon/MultiPolygon a anillos [[lat, lng], ...] para
// dibujarlo con <Polygon> de react-leaflet.
export const anillosDeDistrito = (geojson) => {
  if (!geojson || !geojson.coordinates) return [];
  const aLatLng = (anillo) => anillo.map(([lng, lat]) => [lat, lng]);
  if (geojson.type === 'Polygon') return [aLatLng(geojson.coordinates[0])];
  if (geojson.type === 'MultiPolygon') return geojson.coordinates.map((p) => aLatLng(p[0]));
  return [];
};
